export default __webpack_public_path__ + "static/media/chicken.326da7b5.svg";